/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
Vue.use(Vuesax)


// Filters
import './filters/filters.js'


// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// VeeValidate
import VeeValidate from 'vee-validate'
import { Validator } from 'vee-validate'
import pt_BR from 'vee-validate/dist/locale/pt_BR'

Vue.use(VeeValidate)
Validator.localize('pt_BR', pt_BR)

// axios
import axios from 'axios'

var refCount = 0
function setLoading(loader) {
  if (loader) {
    refCount++;
    store.dispatch('loader/'+'show');
  } else if (refCount > 0) {
    refCount--;
    if (refCount > 0) {
      store.dispatch('loader/'+'show');
    } else {
      store.dispatch('loader/'+'hide');
    }
  }
}

axios.interceptors.response.use(
  function (response) {
    setLoading(false)
    return response
  },
  function (error) {
    setLoading(false)
    // handle error
    if (error.response) {
      if (Array.isArray(error.response.data.messages) && error.response.data.messages) {
        for (const idx in error.response.data.messages) {
          vs.$vs.notify({
            color: 'danger',
            text: error.response.data.messages[idx],
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })
        }
      }
      if (error.response.data.message) {
        vs.$vs.notify({
          title: 'Erro',
          text: error.response.data.message,
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          time: 6000
        })
      }
    }

    if (error.response) {
      if (error.response.status === 403) {
        delete localStorage.token
        delete localStorage.currentUser
        router.push({path: '/pages/login'})
      }
    }

    return Promise.reject(error)
  })

// Lista de endpoints para os quais o loading não deve ser exibido
const excludedEndpoints = [
  'http://localhost:8090/api/v1/finance/credit-report',
  'https://credito.i9dev.com/api/v1/finance/credit-report',
  'https://credito-dev.i9dev.com/api/v1/finance/credit-report',
]

axios.interceptors.request.use(function (config) {
  const token = localStorage.token
  if (token) {
    config.headers.Authorization = token
  }
  // Verifica se o endpoint atual está na lista de excluídos
  if (!excludedEndpoints.some(endpoint => config.url === endpoint)) {
    setLoading(true)
  }

  return config
})

// Feather font icon
require('./assets/css/iconfont.css')
require('./assets/fontawesome/css/all.min.css')


// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false

const vs = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
